import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import ROUTES from '@client-hub/shared/constants/routes'
import MfaBackup from 'components/Mfa/Backup'
import { useMfaNavigateState, useRedirect } from 'hooks'

const MfaEditBackup = () => {
  const navigate = useNavigate()
  const { isAllowedMfa } = useMfaNavigateState()

  useRedirect(!isAllowedMfa)

  const onContinue = useCallback(() => navigate(ROUTES.USERS.MY_PROFILE), [navigate])

  if (!isAllowedMfa) return null

  return <MfaBackup onContinue={onContinue} />
}

export default MfaEditBackup
